export default [{
  name: 'trademaster',
  namespaced: true,
  state: {
    model: {
      Pessoa: {
        PessoaDadosContato: {},
        PessoaBanco: {},
        PessoaEndereco: {},
        Boleto: {},
      },
      Parcela: {},
      Boleto: {},
      Boletos: [],
      BoletosSelecionados: []
    },
    dadosIniciais: {}
  },
  mutations: {
    model (state, obj) {
      state.model = obj
    },
    dadosIniciais (state, obj) {
      state.dadosIniciais = obj
    }
  },
  getters: {
    model (state) {
      return state.model
    },
    dadosIniciais (state) {
      return state.dadosIniciais
    }
  },
  actions: {
    clearModel ({ commit }) {
      const data = {
        Pessoa: {
          PessoaDadosContato: {},
          PessoaBanco: {},
          PessoaEndereco: {},
          Boleto: {},
        },
        Parcela: {},
        Boleto: {},
        Boletos: [],
        BoletosSelecionados: []
      }
      commit('model', data)
      commit('dadosIniciais', {})
    }
  },
}]
